import { render, staticRenderFns } from "./PT506GTMViewCart.vue?vue&type=template&id=53bea8d9&"
import script from "./PT506GTMViewCart.vue?vue&type=script&lang=js&"
export * from "./PT506GTMViewCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports